import Vue from "vue";
import App from "./App.vue";
import Unauthorized from "./views/Unauthorized.vue";
import vuetify from "./plugins/vuetify";
import Keycloak from "keycloak-js";
import axios from "axios";
import router from './router'
// import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";

// Sentry.init({
//   Vue,
//   dsn: process.env.VUE_APP_SENTRY_DSN,
//   integrations: [
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ["localhost", "park-admin.blacktree.io", /^\//],
//     }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

Vue.config.productionTip = false;

const keycloak = new Keycloak({
  realm: process.env.VUE_APP_KC_REALM,
  url: process.env.VUE_APP_KC_URL,
  clientId: process.env.VUE_APP_KC_CLIENT_ID,
});

// Expose the Keycloak instance to every component as `this.$keycloak`
// (drop-in replacement for the property the @dsb-norge plugin used to inject).
Vue.prototype.$keycloak = keycloak;

const tokenInterceptor = () => {
  axios.interceptors.request.use(
    async (config) => {
      // Refresh the access token if it expires within 30s, then attach it.
      try {
        await keycloak.updateToken(30);
      } catch (error) {
        keycloak.logout();
        return Promise.reject(error);
      }
      config.headers.Authorization = `Bearer ${keycloak.token}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

keycloak
  .init({ onLoad: "login-required", checkLoginIframe: false, pkceMethod: "S256" })
  .then((authenticated) => {
    // Not logged in at all → send back to Keycloak.
    if (!authenticated) {
      keycloak.logout();
      return;
    }
    tokenInterceptor();
    // Logged in but missing the admin role → show the "non autorisé" page
    // instead of mounting the admin app (which would trigger 403s).
    if (!keycloak.hasResourceRole("admin", "park-app")) {
      new Vue({
        vuetify,
        render: (h) => h(Unauthorized),
      }).$mount("#app");
      return;
    }
    new Vue({
      vuetify,
      router,
      render: (h) => h(App),
    }).$mount("#app");
  })
  .catch((error) => {
    // eslint-disable-next-line no-console
    console.error("Keycloak initialization failed", error);
  });
